module.exports = "/_next/static/images/CriticalLifeCOVER_Website-Banner-4fe64e20ce037f069bcb70e26abaa0c6.jpg";